import styled from '@emotion/styled';
import { IconButton } from '@material-ui/core';

const StyledIconButton = styled(IconButton)`
  height: 40px;
  width: 40px;
`;

export default StyledIconButton;
